/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc
 */
import * as References from './ApprovalsMetadataRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc#listApprovalSettingsAssets
 */
export const LIST_APPROVAL_SETTINGS_ASSETS_QUERY_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsMetadataRpc_listApprovalSettingsAssets';
export const LIST_APPROVAL_SETTINGS_ASSETS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.ListApprovalSettingsAssetsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LIST_APPROVAL_SETTINGS_ASSETS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ListApprovalSettingsAssetsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.listApprovalSettingsAssetsRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc#listApprovalTypeOptions
 */
export const LIST_APPROVAL_TYPE_OPTIONS_QUERY_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsMetadataRpc_listApprovalTypeOptions';
export const LIST_APPROVAL_TYPE_OPTIONS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.ListApprovalTypeOptionsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: LIST_APPROVAL_TYPE_OPTIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ListApprovalTypeOptionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.listApprovalTypeOptionsRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsMetadataRpc#resolveBreezeAgentNames
 */
export const RESOLVE_BREEZE_AGENT_NAMES_QUERY_FIELD_NAME =
  'com_hubspot_product_approvals_rpc_ApprovalsMetadataRpc_resolveBreezeAgentNames';
export const RESOLVE_BREEZE_AGENT_NAMES_QUERY: RegisteredQuery<
  'result',
  References.ResolveBreezeAgentNamesRequestType,
  References.ResolveBreezeAgentNamesResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: RESOLVE_BREEZE_AGENT_NAMES_QUERY_FIELD_NAME,
  args: ['agentIds'],
  fetcher(
    request: References.ResolveBreezeAgentNamesRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ResolveBreezeAgentNamesResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.resolveBreezeAgentNamesRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
